const agent = {
  AGENT_VIEW_DATA: ['AGENT_VIEW_DATA'] as const,
};

export default agent;
